let audioCtx = null;

function ensureContext() {
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
        audioCtx.resume();
    }
    return audioCtx;
}

function playTone(ctx, frequency, startTime, duration, volume = 0.15) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = frequency;
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(startTime);
    osc.stop(startTime + duration);
}

let lastChirpTime = 0;

export function useBeepSounds() {

    function playMotionStarted() {
        const ctx = ensureContext();
        const now = ctx.currentTime;
        // 2 short beeps at 800Hz
        playTone(ctx, 800, now, 0.12);
        playTone(ctx, 800, now + 0.18, 0.12);
    }

    function playMotionChirp() {
        const now = Date.now();
        if (now - lastChirpTime < 30000) return;
        lastChirpTime = now;

        const ctx = ensureContext();
        // Single short chirp at 1200Hz
        playTone(ctx, 1200, ctx.currentTime, 0.08);
    }

    function playMotionEnded() {
        const ctx = ensureContext();
        const now = ctx.currentTime;
        // 3 short beeps + 1 long beep at 600Hz
        playTone(ctx, 600, now, 0.1);
        playTone(ctx, 600, now + 0.16, 0.1);
        playTone(ctx, 600, now + 0.32, 0.1);
        playTone(ctx, 600, now + 0.48, 0.35);
    }

    function dispose() {
        if (audioCtx) {
            audioCtx.close();
            audioCtx = null;
        }
    }

    return { playMotionStarted, playMotionChirp, playMotionEnded, dispose };
}
